<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="elevation-1">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.native="handleModal">
                <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <v-toolbar-title>Generar reporte de Ingresos y egresos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <SingleCalendar refElement="startDate" title="Fecha inicio" :input-date.sync="filters.startDate" />
                    </v-col>
                    <v-col cols="6">
                        <SingleCalendar refElement="endDate" title="Fecha fin" :input-date.sync="filters.endDate" :min-date="filters.startDate" />
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete :items="brands" item-text="nombre" item-value="id" v-model="filters.sucursalId"
                        label="Sucursales" required outlined prepend-inner-icon="fas fa-id-card-alt"
                        hint="Seleccione la sucursal. Este campo es opcional" dense clearable>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-4" dark class="btn text-white" @click.prevent="downloadTransactionReport">
                    <v-icon left>fas fa-file-pdf</v-icon>Descargar reporte
                </v-btn>
            </v-card-actions>
        </v-card>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob"
        title-pdf="Reporte de transacciones"
        :handlePdfModal="handlePdfModal" :dialog="showPdf" v-if="showPdf">
        </PreviewPDF>
    </v-dialog>
</template>
<script>
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import SingleCalendar from '@/components/shared/SingleCalendar.vue';
import { showErrorAlert, showInfoAlert } from '@/helpers/swalHelper';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import TransactionRecordService from '@/service/transactions/TransactionRecordService';
import { getDateLocaleNatural, getToday } from '@/utils/DateUtil';

export default {
    name: "TransactionReport",
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        brands: { type: Array, default: () => [] }
    },
    components: {
        SingleCalendar, PreviewPDF
    },
    data() {
        return {
            filters: {
                startDate: getToday().toFormat('yyyy-MM-dd'),
                endDate: getToday().toFormat('yyyy-MM-dd'),
                sucursalId: SucursalDataService.getCurrentSucursalId()
            },
            pdfBlob: '',
            pdfSource: null,
            showPdf: false,
        }
    },
    methods: {
        downloadTransactionReport(){
            const startDate = getDateLocaleNatural(this.filters.startDate) ?? '';
            const endDate = getDateLocaleNatural(this.filters.endDate) ?? '';
            const params = { startDate, endDate, sucursalId: this.filters.sucursalId };
            TransactionRecordService.printTransactionReport(params)
            .then( response => {
                if(response.status == 204) {
                    showInfoAlert({ title: 'Reporte de Ingresos/Egresos', text: 'No hay registros para visualizar'});
                    return
                }
                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                this.pdfSource = URL.createObjectURL(this.pdfBlob)
                this.showPdf = true
            }).catch( error => {
                showErrorAlert({ title: 'Error al generar el reporte', text: error.response.data });
            });
        },
        handlePdfModal(){
            this.showPdf = !this.showPdf
            this.cleanupPdf()
        },
        cleanupPdf(){
            if(this.pdfSource){
                URL.revokeObjectURL(this.pdfSource)
                this.pdfSource = null
            }
            this.pdfBlob = null
        }
    }
}
</script>